/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { editAssignmentPriorities, getActiveAssigneesList, getAssignmentsForUser } from "./assignmentsFunctions";
import { FullAssignment, Nullable } from "../../utils/Interfaces";

export function useActiveAssigneesList() {
    return useQuery({
        queryKey: ["OFFICE", "ACTIVE_ASSIGNEES"],
        queryFn: () => getActiveAssigneesList(),
        select: ({ data }) => data,
    });
}

export function useAssignmentsForUser(userId: Nullable<number>) {
    return useQuery({
        queryKey: ["OFFICE", "USER_ASSIGNMENTS", userId],
        queryFn: () => getAssignmentsForUser(userId ?? 0),
        select: ({ data }) => data,
        enabled: !!userId,
    });
}

export function useEditAssignmentPriority(userId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (assignments: FullAssignment[]) => {
            // TODO Define model of the query data.
            queryClient.setQueryData(["OFFICE", "USER_ASSIGNMENTS", userId], {
                data: { results: assignments, count: assignments.length },
            });
            return editAssignmentPriorities(assignments);
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: ["OFFICE", "USER_ASSIGNMENTS", userId] }),
    });
}
